import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { useSelector, useDispatch } from "react-redux";
import { Navigation, Pagination, Autoplay, EffectFade } from "swiper/modules";
import { clearPickupDropoff } from "./../redux/addressSlice";
import { clearShipment } from "./../redux/shipmentSlice";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { toast } from "react-toastify";

import { motion } from "framer-motion"; // for text animation

// import React, { useState, useEffect } from 'react';

// import getGreetingMessage from '../utils/greetingHandler';
// import { useNavigate } from 'react-router-dom';

// import { shallowEqual, useSelector, useDispatch } from "react-redux";
// import { setLanguageId, setLanguageName, setUserData } from '../redux/authSlice';

// import APIs from '../network/APIs';
// import Toast from '../utils/Toast';

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  let title = '';
  if (path === '/about-us') {
    title = 'About Us';
  } else if (path === '/services') {
    title = 'Services';
  } else if (path === '/contact') {
    title = 'Contact Us';
  }
  else if (path === '/service-details') {
    title = 'Service Details';
  }
const navItems = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    { path: "/services", label: "Services" },
    { path: "/contact", label: "Contact Us" },
  ];
  const handleGetQuoteClick = () => {
  // Clear Redux state
  dispatch(clearPickupDropoff());
  dispatch(clearShipment());

  // Clear sessionStorage
  sessionStorage.removeItem("categoryId");
  sessionStorage.removeItem("shipment_id");
  sessionStorage.removeItem("existingQuoteId");
  sessionStorage.removeItem("currentQuoteId");
  sessionStorage.removeItem("categoryName");
  sessionStorage.removeItem("categoryDescription");
  // Navigate programmatically
  navigate(`/Step1/0`); // or whatever your default categoryId should be
};

  return (
    <div className="page-wrapper">
      {/* Header Main Area */}
      <header className="site-header header-style-2">
        {/* Pre Header */}
        <div className="eagle-pre-header-wrapper">
          <div className="container-fluid">
            <div className="d-flex justify-content-between">
              <div className="eagle-pre-header-left">
                <ul className="eagle-contact-info">
                  <li>
                    <i className="eagle-base-icon-mail-alt"></i>
                    <a href="mailto:go@eagleobc.com" className="__cf_email__">
                      go@eagleobc.com
                    </a>
                  </li>
                  <li>
                    <i className="eagle-base-icon-telephone"></i>
                    <a href="tel:+19853778070"> +1 985 3778070</a>
                  </li>
                </ul>
              </div>

              <div className="eagle-pre-header-right">
                <ul className="eagle-contact-info">
                  <li>
                    <ul className="eagle-social-links">
                      <li className="eagle-social-li eagle-social-facebook">
                        <a title="Facebook" href="https://www.facebook.com/profile.php?id=61579233387293" target="_blank" rel="noreferrer">
                          <span><i className="eagle-base-icon-facebook-app-symbol"></i></span>
                        </a>
                      </li>
                      <li className="eagle-social-li eagle-social-twitter">
                        <a title="Twitter" href="#" target="_blank" rel="noreferrer">
                          <span><i className="eagle-base-icon-twitter-2"></i></span>
                        </a>
                      </li>
                      <li className="eagle-social-li eagle-social-linkedin">
                        <a title="LinkedIn" href="#" target="_blank" rel="noreferrer">
                          <span><i className="eagle-base-icon-instagram"></i></span>
                        </a>
                      </li>
                      <li className="eagle-social-li eagle-social-instagram">
                        <a title="Instagram" href="#" target="_blank" rel="noreferrer">
                          <span><i className="eagle-base-icon-youtube-play"></i></span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Main Menu */}
        <div className="site-header-menu">
          <div className="container-fluid">
            <div className="eagle-header-content d-flex justify-content-between align-items-center">
              {/* Logo */}
              <div className="eagle-logo-menuarea d-flex justify-content-between align-items-center">
                <div className="site-branding">
                  <h1 className="site-title">
                    <img className="logo-img" src="/images/logo.png" alt="Logo" />
                  </h1>
                </div>
              </div>

              {/* Navigation */}
              <div className="site-navigation">
                <nav className="main-menu navbar-expand-xl navbar-light">
                  <div className="navbar-header">
                    <button className="navbar-toggler" type="button">
                      <i className="eagle-base-icon-menu-1"></i>
                    </button>
                  </div>
                  <div className="eagle-mobile-menu-bg"></div>
                  <div className="collapse navbar-collapse clearfix show" id="eagle-menu">
                    <div className="eagle-menu-wrap">
                      <span className="closepanel">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20.163"
                          height="20.163"
                          viewBox="0 0 26.163 26.163"
                        >
                          <rect width="36" height="1" transform="translate(0.707) rotate(45)" />
                          <rect width="36" height="1" transform="translate(0 25.456) rotate(-45)" />
                        </svg>
                      </span>
                      <ul className="navigation clearfix">
                        {navItems.map((item) => (
                          <li
                            key={item.path}
                            className={path === item.path ? "active" : ""}
                          >
                            <Link to={item.path}>{item.label}</Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </nav>
              </div>

              {/* Right Buttons */}
              <div className="eagle-right-box d-flex align-items-center">
                <div className="dropdown login-btn">
                  <button className="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="eagle-base-icon-user"></i>
                  </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    {/* If user is NOT logged in → show Login & Register */}
                    {(!sessionStorage.getItem("userData") || sessionStorage.getItem("userData") === "null") && (
                      <>
                        <li>
                          <a
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            href="#LoginModalToggle"
                          >
                            Login
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item"
                            data-bs-toggle="modal"
                            href="#signupModalToggle"
                          >
                            Register
                          </a>
                        </li>
                      </>
                    )}
                    {/* If user IS logged in → show Dashboard */}
                    {sessionStorage.getItem("userData") && (
                      <li>
                        <Link className="dropdown-item" to="/Dashboard">
                        Dashboard
                        </Link>
                      </li>
                    )}
                  </ul>

                </div>

                <div className="eagle-button-box-second">
                  <button
                    className="eagle-btn"
                    onClick={handleGetQuoteClick}
                  >
                    <span className="eagle-button-text">Get A Quote</span>
                    <span className="eagle-button-icon-wrapper">
                      <span className="eagle-button-icon">
                        <i className="eagle-base-icon-black-arrow-1"></i>
                      </span>
                    </span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* header bar */}
        {/* Page Banner Section */}
        {path === "/" ? (
           <div className="eagle-title-bar-wrapper">
            <Swiper
                  modules={[Navigation, Pagination, Autoplay, EffectFade]}
                  autoplay={{ delay: 3000 }}
                  loop={true}
                  pagination={{ clickable: true }}
                  navigation={{
                    nextEl: ".custom-swiper-next",
                    prevEl: ".custom-swiper-prev",
                  }}
                  effect="fade"
                  slidesPerView={1}
                  className="hero-swiper"
                >
                {/* Slide 1 */}
                <SwiperSlide>
                    <div
                    className="eagle-slider-bg"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.3)), url(/images/banner-slider-img/1.jpg)`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                    >
                    <div className="container">
                        <div className="row">
                        <div className="col-md-12 text-center">
                            <div
                            className="eagle-slider-content slide-content"
                            style={{ animation: "fadeUp 1s ease-in-out" }}
                            >
                            <h5 className="eagle-sub-title transform-top transform-delay-1 text-white">
                                Shipping a world of possibility
                            </h5>
                            <h2 className="eagle-title transform-left transform-delay-2 text-white">
                                Seamless Air Transport
                            </h2>
                            <div className="eagle-desc transform-left transform-delay-3 text-white">
                                Experience dependable, efficient air freight solutions tailored
                                to your needs. At Eagle OBC LLC, we ensure timely, secure global
                                cargo delivery.
                            </div>
                            <div className="eagle-button transform-bottom transform-delay-4">
                               <button
                                  className="eagle-btn"
                                  onClick={handleGetQuoteClick}
                                >
                                <span className="eagle-button-text">Get A Quote</span>
                                <span className="eagle-button-icon-wrapper">
                                    <span className="eagle-button-icon">
                                    <i className="eagle-base-icon-black-arrow-1"></i>
                                    </span>
                                </span>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide>
                    <div
                    className="eagle-slider-bg"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.3)), url(/images/banner-slider-img/demo2-slide02.png)`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                    >
                    <div className="container">
                        <div className="row">
                        <div className="col-md-12 text-center">
                            <div
                            className="eagle-slider-content slide-content"
                            style={{ animation: "fadeUp 1s ease-in-out" }}
                            >
                            <h5 className="eagle-sub-title transform-top transform-delay-1 text-white">
                                Shipping a world of possibility
                            </h5>
                            <h2 className="eagle-title transform-left transform-delay-2 text-white">
                                Fast Delivery
                            </h2>
                            <div className="eagle-desc transform-left transform-delay-3 text-white">
                                Experience dependable, efficient air freight solutions tailored
                                to your needs. At Eagle OBC LLC, we ensure timely, secure global
                                cargo delivery.
                            </div>
                            <div className="eagle-button transform-bottom transform-delay-4">
                               <button
                                className="eagle-btn"
                                onClick={handleGetQuoteClick}
                              >
                                <span className="eagle-button-text">Get A Quote</span>
                                <span className="eagle-button-icon-wrapper">
                                    <span className="eagle-button-icon">
                                    <i className="eagle-base-icon-black-arrow-1"></i>
                                    </span>
                                </span>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </SwiperSlide>

                {/* Slide 3 */}
                <SwiperSlide>
                    <div
                    className="eagle-slider-bg"
                    style={{
                        backgroundImage: `linear-gradient(0deg, rgba(0,0,0,0.5), rgba(0,0,0,0.3)), url(/images/banner-slider-img/2.jpg)`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                    }}
                    >
                    <div className="container">
                        <div className="row">
                        <div className="col-md-12 text-center">
                            <div
                            className="eagle-slider-content slide-content"
                            style={{ animation: "fadeUp 1s ease-in-out" }}
                            >
                            <h5 className="eagle-sub-title transform-top transform-delay-1 text-white">
                                Shipping a world of possibility
                            </h5>
                            <h2 className="eagle-title transform-left transform-delay-2 text-white">
                                Global Cargo
                            </h2>
                            <div className="eagle-desc transform-left transform-delay-3 text-white">
                                Experience dependable, efficient air freight solutions tailored
                                to your needs. At Eagle OBC LLC, we ensure timely, secure global
                                cargo delivery.
                            </div>
                            <div className="eagle-button transform-bottom transform-delay-4">
                                 <button
                                  className="eagle-btn"
                                  onClick={handleGetQuoteClick}
                                >
                                <span className="eagle-button-text">Get A Quote</span>
                                <span className="eagle-button-icon-wrapper">
                                    <span className="eagle-button-icon">
                                    <i className="eagle-base-icon-black-arrow-1"></i>
                                    </span>
                                </span>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </SwiperSlide>
                {/* Custom Navigation Buttons */}
                <div className="custom-swiper-prev">
                    <i className="eagle-base-icon-black-arrow-1"></i>
                </div>
                <div className="custom-swiper-next">
                    <i className="eagle-base-icon-black-arrow-1"></i>
                </div>
            </Swiper>
            </div>
        )  : title ? (
          <div className="eagle-title-bar-wrapper">
            <div className="container">
              <div className="eagle-title-bar-content">
                <div className="eagle-title-bar-content-inner">
                  <div className="eagle-tbar">
                    <div className="eagle-tbar-inner container">
                      <h1 className="eagle-tbar-title">{title}</h1>
                    </div>
                  </div>
                  <div className="eagle-breadcrumb">
                    <div className="eagle-breadcrumb-inner">
                      <span>
                        <Link to="/" className="home">
                          <span>Home</span>
                        </Link>
                      </span>
                      <span className="sep">
                        <i className="eagle-base-icon-angle-right"></i>
                      </span>
                      <span>
                        <span className="post-root current-item">{title}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null }
        
        {/* end header bar */}
      </header>
      {/* Header Main Area End */}
    </div>
  );
}
export default Header;